import Todo from "./todo";
import MyCats from "./my_cats";

function Dashboard() {
  return (
    <div className="flex flex-col gap-4">
      <MyCats />
    </div>
  );
}

export default Dashboard;
